import { Injectable, Injector } from '@angular/core';
import { AgricultureMapConstants, COMMON_LAYER_LIST, LAYER_TYPES } from '../constants/dims-map-constants';
import { isNullOrUndefined } from 'util';
import * as L from 'leaflet';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { UtilsService } from 'src/app/utils/utils.service';
import 'src/assets/js/maplibs/L.TileLayer.ColorFilter.js'
import 'src/assets/js/maplibs/L.TileLayer.ColorFIlter.min.js'
import 'src/assets/js/maplibs/L.vectorgrid.bundle.js';
// import 'leaflet-bing-layer';
// import * as GeoJSON from 'geojson';


@Injectable({
  providedIn: 'root'
})
export class GisdataService {
  urlConstants: any = environment.url;
  bbox: any = '';

  constructor(
    public gisUtils: UtilsService,
    private injector: Injector,
    private http: HttpClient,
    // private weatherForecastSrv: WeatherForecastService,
    // private soilMoistureDataSrv : SoilMositureDataService,
    // private geoportalSrv: GeoportalMapService,
    // private utilsSrv: UtilsService,
    private toasterSrv : ToastrService,
    private router : Router,
    private route : ActivatedRoute,
  ) { }


  addBaseTileLayers(layerList: any, baseIndex: any, mapObj: any) {
    //gallery selection if they have picked one
    const savedIndex = localStorage.getItem('selectedBaseMapIndex');
    const effectiveIndex = savedIndex !== null ? savedIndex : baseIndex;
    let baselayers: any = {}
    for (let index in layerList) {
      let layer: any = layerList[index];
      if (index == effectiveIndex) {
        layer['visible'] = true
      } else {
        layer['visible'] = false
      }
      let layerObj
      layerObj = this.addTileLayer(layer);
      mapObj.removeLayer(layerObj);
      if (layer['visible']) {
        mapObj.addLayer(layerObj);
      }
      baselayers[layer['name']] = layerObj;
    }
    return baselayers;
  }

  addTileLayer(layerOptions: any) {
    let tileLayer;
    if (layerOptions.name === 'Google Satellite') {
      tileLayer = (L.tileLayer as any).colorFilter(
        layerOptions.url,
        layerOptions
      );
    } else if (layerOptions.name == 'Bing') {
      tileLayer = (L as any).tileLayer.bing(layerOptions.token);
    } else {
      tileLayer = new L.TileLayer(layerOptions.url, layerOptions);
    }
    return tileLayer;
  }
  getApplicationBasedLayer(layerList: any, layerType: any, params?: any) {
    if (layerType == LAYER_TYPES.WMS_LAYER) {
      return this.getWMSOverLays(layerList, params);
    } else if (layerType == LAYER_TYPES.VECTOR_LAYER) {
      return this.getVECTOROverlays(layerList, params);
    } else if (layerType == LAYER_TYPES.GEOJSON_LAYER) {
      return this.getGEOJSONOverLays(layerList);
    } else if (layerType == LAYER_TYPES.HEATMAP_LAYER) {
      return this.getHeatMapOverlays(layerList, {})
    }
  }
  getWMSOverLays(data: any, params?: any) {
    // console.log("WMS DATA::",data);

    let overlays: any = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'wms';
        overlay.component = value.component;
        overlay.layerOptions = {};
        if (value.cType && value.cType.length > 0) {
          overlay.layerOptions.cType = value.cType;
        }
        if (params && params['pUUID']) {
          overlay.layerOptions.pUUID = params['pUUID'];
        }
        overlay.layerOptions.name = value.name;
        overlay.layerOptions.format = 'image/png';
        overlay.layerOptions.transparent = true;
        overlay.layerOptions.workspaceName = value.layeroptions_name.split(':')[0] == 'visualisation' ? 'visualization' : value.layeroptions_name.split(':')[0];
        overlay.url = this.getGeoServerURL(value.environment_server_url, overlay.layerOptions.workspaceName) + "wms";
        if (this.validateValue(value.env)) {
          overlay.layerOptions.env = value.env;
        }
        if (this.validateValue(value.viewparams)) {
          overlay.layerOptions.VIEWPARAMS = value.viewparams;
        }
        if(this.validateValue(value.VIEWPARAMS)){
          overlay.layerOptions.VIEWPARAMS = value.VIEWPARAMS;
        }
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.key))
          overlay.layerOptions.key = value.key;
        if (this.validateValue(value.view))
          overlay.layerOptions.view = value.view;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.imagesrc))
          overlay.layerOptions.imagesrc = value.imagesrc;
        if (this.validateValue(value.source))
          overlay.layerOptions.source = value.source;
        if (this.validateValue(value.layer_name))
          overlay.layerOptions.layer_name = value.layer_name;
        if (this.validateValue(value.cql_filter))
          overlay.layerOptions.cql_filter = value.cql_filter;
        if (this.validateValue(value.cql_filter_value)) {
          overlay.layerOptions.cql_filter_value = value.cql_filter_value;
        }
        if (this.validateValue(value.viewParams))
          overlay.layerOptions.viewParams = value.viewparams
        if (this.validateValue(value.subgroup))
          overlay.layerOptions.subgroup = value.subgroup;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.dashboardView))
          overlay.layerOptions.dashboardView = value.dashboardView;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layers = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_zindex)) {
          overlay.layerOptions.zIndex = value.layeroptions_zindex;
        }
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type
        }
        if (this.validateValue(value.data)) {
          overlay.layerOptions.data = value.data
        }
        if (this.validateValue(value.crs) && value.crs == "EPSG4326") {
          overlay.layerOptions.crs = L.CRS.EPSG4326;
        }
        if (this.validateValue(value.position)) {
          overlay.layerOptions.position = value.position;
        }
        if (this.validateValue(value.time)) {
          overlay.layerOptions.time = value.time;
        }
        if (this.validateValue(value.groupName)) {
          overlay.layerOptions.groupName = value.groupName;
        }
        if (value.type === 'WMS') {

          if (overlay.name === 'Sentinel 1' || overlay.name === 'Sentinel 2 FCC' || overlay.name === 'Sentinel 2 TCC' ||
            overlay.name.includes('ALOS')) {
            overlay.key = overlay.name;
            overlays[overlay.name] = overlay;
          }
          else {
            overlay.key = key;
            overlay.layerOptions.key = key;
            overlays[key] = overlay;
          }
        }
        if (this.validateValue(value.layeroptions_styles)) {
          overlay.layerOptions.STYLES = value.layeroptions_styles;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
        if (this.validateValue(value.environment_server_url)) {
          overlay.layerOptions.environment_server_url = value.environment_server_url;
        }
        overlay.layerOptions.tiled = true;
      }
    }
    return overlays;
  }
  getGeoServerURL(geo?: any, workspaceName?: any) {
    let url: any = this.urlConstants[geo];
    // let url: any = this.urlConstants.AIMS_GEOSERVER_URL + 'agristack';
    return url;
  }

  validateValue(value: any) {
    if (isNullOrUndefined(value)) {
      return false;
    }
    return true;
  }
  getGeoJsonLayerData(layerName: any, filter: any, workspaceName: any, environment_server_url: any, protocol: any,gisMapComp:any): Promise<any> {
    let response = {};
    let promise = new Promise((resolve, reject) => {
      this.getLayerWithFilter(layerName, filter, workspaceName, environment_server_url, protocol).subscribe(async (geodata: any) => {
        let params: any = gisMapComp.params;
        let locType = !isNullOrUndefined(params['locType']) ? params['locType'] : null;
        if (geodata) {
          console.log("LAYER CHECKK::",layerName,locType);

          if (!isNullOrUndefined(locType) && layerName.includes(locType)) {
            geodata['layerName'] = layerName;
            // this.weatherForecastSrv.setGEOJSONDataForWeatherForecast(geodata);
            // this.soilMoistureDataSrv.setGEOJSONDataForSoilMoisture(geodata);
          } else {
            console.log("Condition not met. locTypeLower: ", locType, " layerNameLower: ", locType);
          }
          resolve(geodata);
        }
      });
      (err: any) => {
        console.log("Error Occurred", err);
        reject(response);
      }
    });
    return promise;
  }

  async setGEOJSONOverlays(mapObject: any, layerList: any, layerObjectsList: any, otherOptions: any, gisMapComp?: any): Promise<any> {
    gisMapComp.spinner = true;
    return new Promise(async (resolve, reject) => {
      let params: any = gisMapComp.params;
      // params['locType'] = params['locType'] == 'KRISHI_BHAVAN' ? 'KRISHIBHAVAN' : params['locType'];
      let geoJsonOverlay: any = {};
      let locationGeoData : any;
      let filter = null;
      for (const key in layerList) {
        if (layerObjectsList.overlaylayers.hasOwnProperty(key)) {
          if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
            mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
          }
        }
        // if (layerObjectsList.userLoginOverylayLayer.hasOwnProperty(key)) {
        //   if (mapObject.hasLayer(layerObjectsList['userLoginOverylayLayer'][key])) {
        //     mapObject.removeLayer(layerObjectsList['userLoginOverylayLayer'][key]);
        //   }
        // }
        let concentricCircleLayer: any = new L.LayerGroup();
        const val = layerList[key];
        if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == AgricultureMapConstants.SOURCES.BACKEND) {
          let srv = this.injector.get(otherOptions['serviceType']);
          concentricCircleLayer = await srv[otherOptions['sensorLayerFunctionName']](this, val, mapObject);
        }
        else if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == AgricultureMapConstants.SOURCES.GEOSERVER) {
          let layerName = val.layerOptions.layers.includes('HEATWAVE:') ? val.layerOptions.layers.split('HEATWAVE:') : val.layerOptions.layers.includes('HEATWAVE:') ? val.layerOptions.layers.split('HEATWAVE:') : val.layerOptions.layers.split('odisha:');
          let workspaceName: any = val.layerOptions.layers.split(':')[0];
          let environment_server_url: any = val.layerOptions.environment_server_url;
          let protocol: any = val.layerOptions.protocol;
          if (val.layerOptions.displayName == 'Field Polygons' || val.layerOptions.displayName == 'Farm Polygons') {  // condition to apply viewParams on layer
            filter = this.getviewParamsFilterForLayers(val.layerOptions)
          }
          else
            filter = this.getCqlFilterForLayers(val.layerOptions);
          if (layerName[1] != null || layerName[1] != undefined) {
            let geodata: any;
            if (protocol == 'WFS') {
              geodata = await this.getGeoJsonLayerData(layerName[1], filter, workspaceName, environment_server_url, protocol,gisMapComp);
            } else if (protocol == 'WMS') {
              geodata = await this.getGeoJsonVectorLayerData(layerName[1], workspaceName, filter, val.layerOptions);
              if (gisMapComp.params.component == 'GROUNDTRUTH') {
                let data: any = {
                  'geodata': geodata,
                  'mapObject': mapObject,
                  'layer': val,
                  'otherOptions': otherOptions,
                  'gisMapComp': gisMapComp,
                  'key': key
                }
                this.gisUtils.geoData.next(data);
              }
            }
            locationGeoData = Object.assign(geodata);
            concentricCircleLayer = await this.addGeoJsonLayersToMap(geodata, mapObject, val.layerOptions, otherOptions, gisMapComp);
          }
        }

        concentricCircleLayer['options'] = { ...val, ...concentricCircleLayer['options'] };
        geoJsonOverlay[key] = concentricCircleLayer;
        geoJsonOverlay[key].options = { ...geoJsonOverlay[key].options, ...concentricCircleLayer['options']['layerOptions'] };
        // if (!isNullOrUndefined(mapObject) && !isNullOrUndefined(geoJsonOverlay[key]) &&
        //   this.checkZoomlevelsForGeoJSON(geoJsonOverlay[key].options, mapObject.getZoom()) && geoJsonOverlay[key].options.visible) {
        //   }
        if (geoJsonOverlay[key].options.visible) {
          // if (gisMapComp.params?.component != 'CROPGROWTH') {
            mapObject.addLayer(geoJsonOverlay[key]);
          // } else if (gisMapComp.params.component == 'CROPGROWTH') {
          //   if (gisMapComp.params.locationType != 'user-defined') {
          //     mapObject.addLayer(geoJsonOverlay[key]);
          //   }
          // }
        }
        if (params.hasOwnProperty('locType')) {
          if (key.includes(this.gisUtils.titleCase(params.locType))) {
            if (gisMapComp.params.component == 'CROPGROWTH' || gisMapComp.params.component == 'CROPGROWTHANALYSIS') {
              if (!gisMapComp.params.isAoiClicked) {
                gisMapComp.map.fitBounds(geoJsonOverlay[key].getBounds());
              }
            } else {
              let latlng = locationGeoData['features'][0]['properties'];
              if(params.locType == "WARD" || params.locType == "LAC" || params.locType == 'COUNTRY') {
                gisMapComp.map.fitBounds(geoJsonOverlay[key].getBounds());
                if (params.locType == 'COUNTRY') gisMapComp.homeBounds = geoJsonOverlay[key].getBounds();
              }
              else {
                const lat = latlng['Latitude'] || latlng['latitude'];
                const lng = latlng['Longitude'] || latlng['longitude'];
                gisMapComp.map.setView([lat, lng], AgricultureMapConstants.LOCTYPE_VS_ZOOMLEVEL[params.locType.toUpperCase()], { animate: false });
              }

            //                 else
            //     gisMapComp.map.setView([latlng['Latitude'],latlng['Longitude']],AgricultureMapConstants.LOCTYPE_VS_ZOOMLEVEL[params.locType.toUpperCase()])

            // }

            }
          }
        }
        if (params.hasOwnProperty('locType')) {
          let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
          let child: any = this.gisUtils.titleCase(hie[hie.indexOf(params.locType) + 1]);
          // if (key.includes(this.gisUtils.titleCase(child))) {
            if (isNullOrUndefined(geoJsonOverlay[key]['options']['restrictFitBounds']) && !isNullOrUndefined(geoJsonOverlay[key].getBounds())) {
              gisMapComp.map.fitBounds(geoJsonOverlay[key].getBounds());
              // Remember the country-level fit so the Home button restores this same default view
              if (params.locType == 'COUNTRY') gisMapComp.homeBounds = geoJsonOverlay[key].getBounds();
            }
          // }
        }
        setTimeout(() => {
          if (gisMapComp.params.component != 'CROPGROWTH' || gisMapComp.params.component != 'CROPGROWTHANALYSIS') {
            if (key.includes('User') || key == 'Village') {
              if (!isNullOrUndefined(geoJsonOverlay[key].getBounds())) {
                gisMapComp.map.fitBounds(geoJsonOverlay[key].getBounds());
              }
            }
          }
        }, 1000)
      }
      if(gisMapComp.dataTabCSS != "weatherForecast"){
        gisMapComp.spinner = false;
      }
      console.log("geoJsonOverlay",geoJsonOverlay);

      resolve(geoJsonOverlay);
    });
  }
  async getGeoJsonVectorLayerData(layerName: any, workspace: any, cql_filter: any, options: any) {
    let layerAndWorkspaceName: any = options.parent_lname.split(':');
    let lname: any = layerAndWorkspaceName[1];
    let filter: any = options.parent_cql_filter;
    let workspaceName: any = layerAndWorkspaceName[0];
    let urlKey: any = options.environment_server_url;
    let bounds: any = await this.getBoundsFromParentLayerForChild(lname, filter, workspaceName, urlKey, 'WFS');
    return new Promise((resolve, reject) => {
      this.getGeoJsonWMSWithFilter(layerName, cql_filter, workspace, urlKey, bounds).subscribe((geoData: any) => {
        resolve(geoData);
      });
    });
  }
  getBoundsFromParentLayerForChild(lname: any, filter: any, workspaceName: any, urlKey: any, protocol: any) {
    return new Promise((resolve, reject) => {
      this.getLayerWithFilter(lname, filter, workspaceName, urlKey, protocol).subscribe((geoData: any) => {
        let geodata: any = new L.GeoJSON(geoData);
        let bounds: any = geodata.getBounds();
        resolve(bounds);
      });
    });
  }

  getGeoJsonWMSWithFilter(layerName: any, filter?: any, workspaceName?: any, urlKey?: any, bbox?: any): any {
    if (!isNullOrUndefined(bbox)) {
      let layerURL: any = this.urlConstants[urlKey] + workspaceName + '/wms?service=WMS&version=1.1.0&request=GetMap&layers=' + workspaceName + ':' + layerName + '&bbox=' + bbox.toBBoxString() + '&width=768&height=713&srs=EPSG%3A4326&styles=&format=geojson';
      if (filter) {
        layerURL += '&viewParams=' + filter;
      }
      return this.http.get<any>(layerURL);
    }
  }
  getLayerWithFilter(layerName: any, filter?: any, workspaceName?: any, urlKey?: any, protocol?: any) {
    let layerURL: any = '';
    if (protocol == 'WFS') {
      layerURL = this.urlConstants[urlKey] + workspaceName + "/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=" + workspaceName + ":" + layerName + "&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    } else {
      layerURL = this.urlConstants[urlKey] + workspaceName + '/wms?service=WMS&version=1.1.0&request=GetMap&layers=' + workspaceName + ':' + layerName + '&bbox=78.6216104137187%2C18.94030055993545%2C78.68439561555438%2C18.9986469278273&width=768&height=713&srs=EPSG%3A4326&styles=&format=geojson';
    }
    if (filter) {
      let isViewParams: boolean = filter.includes('VIEWPARAMS');
      if (!isViewParams) {
        layerURL += '&cql_filter=' + filter;
      } else {
        layerURL += filter;
      }
    }
    return this.http.get<any>(layerURL);
  }
  getCqlFilterForLayers(layerOptions: any) {
    let filter = null;
    filter = layerOptions.cql_filter || null;
    return filter;
  }
  getviewParamsFilterForLayers(layerOptions: any) {
    let filter = null;
    filter = layerOptions.viewparams || null;
    return filter;
  }
  addGeoJsonLayersToMap(geoJsonData: any, mapObj: L.Map, layerOptions: any, otherOptions: any, gisMapComp: any, params?: any) {
    let service = this.injector.get(otherOptions['serviceType']);
    let geoJsonLayer = L.geoJSON(geoJsonData, {
      style: function (feature) { if (layerOptions.style) return service[layerOptions.style](feature, gisMapComp); },
      pointToLayer: (feature, layer) => {
        if (layerOptions.pointToLayer)
          return service[layerOptions.pointToLayer](feature, mapObj, params, gisMapComp)
      },
      onEachFeature: function (feature, layer) {
        if (layerOptions.onEachFeature)
          return service[layerOptions.onEachFeature](layer, mapObj, params, gisMapComp)
      },
      pane: layerOptions.pane
    });
    if (layerOptions.afterLayerAddition && service[layerOptions.afterLayerAddition] && geoJsonData && geoJsonData['features'] && geoJsonData['features'].length > 0) {
      service[layerOptions.afterLayerAddition](gisMapComp);
    }
    return geoJsonLayer;
  }
  checkZoomlevelsForGeoJSON(layeroptions: any, currentZoom: any) {
    if (layeroptions && layeroptions['maxZoom'] && layeroptions['minZoom'] && layeroptions['maxZoom'] >= currentZoom && layeroptions['minZoom'] <= currentZoom && layeroptions['visible']) return true;
    return false;
  }
  getGEOJSONOverLays(data: any) {
    let overlays: any = {};
    for (const key in data) {
      if (data.hasOwnProperty(key) && !isNullOrUndefined(data[key])) {
        const value = data[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'GEOJSON';
        overlay.layerOptions = {};
        if (value.cType && value.cType.length > 0) {
          overlay.cType = value.cType;
          overlay.layerOptions.cType = value.cType;
        }
        overlay.layerOptions.type = 'GEOJSON';
        overlay.layerOptions.name = value.name;
        overlay.layerOptions.format = 'image/png';
        overlay.layerOptions.transparent = true;
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.legendData))
          overlay.layerOptions.legendData = value.legendData;
        if (this.validateValue(value.component))
          overlay.layerOptions.component = value.component;
        if (this.validateValue(value.view))
          overlay.layerOptions.view = value.view;
        if (this.validateValue(value.layer_name))
          overlay.layerOptions.layer_name = value.layer_name;
        if (this.validateValue(value.cqlfilter))
          overlay.layerOptions.cql_filter = value.cqlfilter;
        if (this.validateValue(value.cql_filter_value))
          overlay.layerOptions.cql_filter_value = value.cql_filter_value;
        if (this.validateValue(value.source))
          overlay.layerOptions.source = value.source;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.layerFrom))
          overlay.layerOptions.layerFrom = value.layerFrom;
        if (this.validateValue(value.includeAll))
          overlay.layerOptions.includeAll = value.includeAll;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.style))
          overlay.layerOptions.style = value.style;
        if (this.validateValue(value.onEachFeature))
          overlay.layerOptions.onEachFeature = value.onEachFeature;
        if (this.validateValue(value.pointToLayer))
          overlay.layerOptions.pointToLayer = value.pointToLayer;
        if (this.validateValue(value.afterLayerAddition))
          overlay.layerOptions.afterLayerAddition = value.afterLayerAddition;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.canalWMSLayer))
          overlay.layerOptions.canalWMSLayer = value.canalWMSLayer;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layers = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_zindex)) {
          overlay.layerOptions.zIndex = value.layeroptions_zindex;
        }
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type
        }
        if (this.validateValue(value.data)) {
          overlay.layerOptions.data = value.data
        }
        if (this.validateValue(value.crs) && value.crs == "EPSG4326") {
          overlay.layerOptions.crs = L.CRS.EPSG4326;
        }
        if (this.validateValue(value.position)) {
          overlay.layerOptions.position = value.position;
        }
        if (value.type === 'GEOJSON') {
          overlay.key = key;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.layeroptions_styles)) {
          overlay.layerOptions.STYLES = value.layeroptions_styles;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
        if (this.validateValue(value.environment_server_url)) {
          overlay.layerOptions.environment_server_url = value.environment_server_url;
        }
        if (this.validateValue(value.layeroptions_protocol)) {
          overlay.layerOptions.protocol = value.layeroptions_protocol;
        }
        if (this.validateValue(value.layeroptions_parent_lname)) {
          overlay.layerOptions.parent_lname = value.layeroptions_parent_lname;
        }
        if (this.validateValue(value.parent_cql_filter_key)) {
          overlay.layerOptions.parent_cql_filter_key = value.parent_cql_filter_key;
        }
        if (this.validateValue(value.viewparams)) {
          overlay.layerOptions.viewparams = value.viewparams;
        }
        if (this.validateValue(value.restrictFitBounds)) {
          overlay.layerOptions.restrictFitBounds = value.restrictFitBounds;
        }
      }
    }
    return overlays;
  }
  isEmptyObj(obj: any) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }
  getWritableObject(obj: any): object {
    if (obj == null || obj == undefined) return obj;
    let objectConfig: any = {};
    for (let key in obj) {
      objectConfig[key] = obj[key];
    }
    return objectConfig;
  }

  setWMSOverlays(mapObject: any, wmsLayers: any, layersList?: any) {
    let layers: any = {};
    for (const key in wmsLayers) {
      if (wmsLayers.hasOwnProperty(key)) {
        const layer: any = wmsLayers[key];
        // console.log(wmsLayers[key])
        if (!layer.layerOptions.cql_filter) {
          if (key != 'Final Farm Boundary') {
            layer.layerOptions.cql_filter = '1=1';
          }
        }
        let wmslayer = new L.TileLayer.WMS(layer.url, layer.layerOptions)
        layers[key] = wmslayer;
        if (layersList) {
          if (layersList.hasOwnProperty(key)) {
            if (mapObject.hasLayer(layersList[key])) {
              mapObject.removeLayer(layersList[key])
            }
          }
        }
        if (key == "Boonidhi" || key == "BoonidhiDouble") {
          layer.url = "https://bhoonidhi.nrsc.gov.in/geoserver/visualization/wms";
          layer.continuousWorld = true;
          layer.layerOptions.continuousWorld = true;
          // layer.layerOptions.format = "image/geotiff"


        }
        if (!key.startsWith('Depth_Class'))
          if (layer.layerOptions.visible === true) {
            if (!mapObject.hasLayer(layers[key])) {
              mapObject.addLayer(layers[key])
            }
          }
      }
    }
    return layers;
  }
  setVECTOROverlays(mapObj: any, vectorLayer: any, submodule?: any, layerList?: any, params?: any, queryParams?: any, gisMapComp?: any) {
    const layers: any = {};
    for (const key in vectorLayer) {
      const layer = vectorLayer[key];
      if (this.validateValue(layer.layerOptions.cql_filter) && !(layer.url).includes('cql_filter')) {
        layer.url += '&cql_filter=' + layer.layerOptions.cql_filter;
      }
      if (this.validateValue(layer.layerOptions.VIEWPARAMS)) {
        layer.url += '&VIEWPARAMS=' + layer.layerOptions.VIEWPARAMS;
      }
      const vectorTileLayer = new (L as any).vectorGrid.protobuf(layer.url, {
        ...layer.layerOptions,
        interactive: true,
        bounds: L.latLngBounds(
          [6.762375831604004, 68.14484405517578],
          [37.0782777319336, 97.46739196777344]
        )
      });
      // Ward-name hover popup (Urban Heat Island) needs to track the cursor rather than stay
      // pinned at the mouseover point, unlike the other componentType popups below — this
      // closure var is scoped per-layer (key) and only ever touched by the 'uhi' branches.
      let uhiHoverPopup: any = null;
      vectorTileLayer.on({
        mouseover: (e: any) => {
          let area;
          // if (key.includes('Boundary')) {
          //   area = e.sourceTarget.properties.area_sqkm;
          //   area = this.utilsSrv.convertSqMtrsToHectare(area)
          //   const popup = L.popup({ autoPan: false, minWidth: 250, pane: 'measuretool', maxWidth: 300, closeButton: true })
          //   popup.setContent(this.geoportalSrv.setHtmlContentForBasin(area));
          //   popup.setLatLng(e['latlng']).openOn(mapObj)
          // }
          if (key == 'Basin' || key == 'Sub Basin') {
            area = e.sourceTarget.properties.areainsqkm;
            // area = this.utilsSrv.convertSqMtrsToHectare(area)
            const popup = L.popup({ autoPan: false, minWidth: 250, pane: 'measuretool', maxWidth: 300, closeButton: true })
            // popup.setContent(this.geoportalSrv.setHtmlContentForBasin(area));
            popup.setLatLng(e['latlng']).openOn(mapObj)
          }
          if (key == 'Soil Erosion') {
            const popup = L.popup({ autoPan: false, minWidth: 250, pane: 'measuretool', maxWidth: 300, closeButton: true })
            // popup.setContent(this.geoportalSrv.setHtmlContentForSoilErosion(e.sourceTarget.properties));
            popup.setLatLng(e['latlng']).openOn(mapObj)
          }
          if (key == 'Geomorphology' || key == 'Geology') {
            const popup = L.popup({ autoPan: false, minWidth: 250, pane: 'measuretool', maxWidth: 300, closeButton: true })
            // popup.setContent(this.geoportalSrv.setHtmlContentForThematicLayers(e.sourceTarget.properties, key));
            popup.setLatLng(e['latlng']).openOn(mapObj)
          }
          if (gisMapComp.componentType == 'coldwave') {
            const popup = L.popup({ autoPan: false, minWidth: 250, pane: 'measuretool', maxWidth: 300, closeButton: true })
            popup.setContent(gisMapComp.injectedService.setHtmlContentForColdwavePopup(e.sourceTarget.properties, gisMapComp));
            popup.setLatLng(e['latlng']).openOn(mapObj)
          }
          if (gisMapComp.componentType == 'monitor' || gisMapComp.componentType == 'heatlog' || gisMapComp.componentType == 'feed') {
            const popup = L.popup({ autoPan: false, minWidth: 100, pane: 'measuretool', maxWidth: 300, closeButton: true })
            popup.setContent(gisMapComp.injectedService.setHtmlContentForDistrict(e.sourceTarget.properties));
            popup.setLatLng(e['latlng']).openOn(mapObj)
          }
          if (gisMapComp.componentType == 'uhi') {
            const popup = L.popup({ autoPan: false, minWidth: 100, pane: 'measuretool', maxWidth: 300, closeButton: true })
            popup.setContent(gisMapComp.injectedService.setHtmlContentForWard(e.sourceTarget.properties));
            popup.setLatLng(e['latlng']).openOn(mapObj)
            uhiHoverPopup = popup;
          }
        },
        mousemove: (e: any) => {
          if (gisMapComp.componentType == 'uhi' && uhiHoverPopup) {
            uhiHoverPopup.setLatLng(e['latlng']);
          }
        },
        mouseout: (e: any) => {
          if (e.target.options.component != "CROPSOWNANALYSIS" || e.target.options.component === 'HARVESTASSESSMENT') {
            mapObj.closePopup()
          }
          uhiHoverPopup = null;
        },
        click: (e: any) => {
          console.log("CLICKK::",e);
          let properties: any = e.sourceTarget.properties
          let options: any = { ...params };
          let allLocations: any = params['location'].split('&');
          if (gisMapComp['otherOptions']['onLocationClick']) {
            console.log("onLocationClick");
            this.onLocationClick(properties, allLocations, gisMapComp, options, key);
          }
          if (gisMapComp.params.component == 'FOG' && !gisMapComp['otherOptions']['onLocationClick']) {
            if (key == 'Airport Boundary' || key == 'Railway Boundary' || key == 'Highway Boundary') {
              gisMapComp.injectedService.setViewForFogForecastLayers(key, properties, gisMapComp)
            }
          }
          if(e.target.options.component === 'DROUGHT'){
            // this.droughtDataService.onVectorClick.next(e);
          } else if (e.target.options.component === 'HARVESTASSESSMENT' || e.target.options.component === "CROPSOWNANALYSIS") {
            if(key == 'Farm Polygons'){
              let currentZoom = gisMapComp.map.getZoom();
              if (e.originalEvent.detail !== 2) {
                if (Math.floor(currentZoom) < 17) {
                  this.toasterSrv.error('Please Zoom In To Select Field');
                } else {
                  const popup = L.popup({ autoPan: false, minWidth: 250, pane: 'measuretool', maxWidth: 300, closeButton: true })
                  // popup.setContent(this.setHtmlForBundsForHA(e));
                  popup.setLatLng(e['latlng']).openOn(mapObj)
                  // layer.bindPopup(popup);
                }
              }
            }
        }
      }
    })

      layers[key] = vectorTileLayer;
      if (layer.layerOptions.visible == true) {
        if (layerList.hasOwnProperty(key)) {
          if (mapObj.hasLayer(layerList[key])) {
            mapObj.removeLayer(layerList[key])
          }
        }
        mapObj.addLayer(layers[key]);
        // layers[key].on('load', function() {
        //   gisMapComp.showThrobber = false
        // })
      }
    }
    return layers;
  }
  onLocationClick(properties: any, allLocations: any, gisMapComp: any, options: any,key: any) {
    let mergeOptions = this.updateOptions(properties, allLocations, options, key, gisMapComp);
    console.log("mergeOptions",mergeOptions,this.route,options);
    // gisMapComp['router'].navigate(['/' + gisMapComp.routeParams.dashboard + '/' + gisMapComp.componentType +'/akbm'], {
    //   relativeTo: gisMapComp['route'],
    //   queryParams: options,
    //   queryParamsHandling: 'merge'
    // });
    // sessionStorage.setItem('params',options)
    gisMapComp.gisUtils.setSelectedParams(options)
  }
  updateOptions(properties: any, allLocations: any, options: any,key: any, gisMapComp:any) {
    console.log("options",options,properties,key);

    // if (properties.kb_uuid) {
    //   options['locType'] = 'KRISHIBHAVAN';
    //   options['pUUID'] = properties.kb_uuid;
    //   options['locName'] = this.gisUtils.titleCase(properties.kb_name);
    //   options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + allLocations[2] + '&' + allLocations[3] + '&' + this.gisUtils.titleCase(properties.kb_name) + '##' + properties.kb_uuid;
    // } else if (properties.ada_uuid) {
    //   options['locType'] = 'ADA';
    //   options['pUUID'] = properties.ada_uuid;
    //   options['locName'] = this.gisUtils.titleCase(properties.ada_name);
    //   options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + allLocations[2] + '&' + this.gisUtils.titleCase(properties.ada_name) + '##' + properties.ada_uuid;
    // }else if (properties.lsc_uuid) {
    //   options['locType'] = 'LSC';
    //   options['pUUID'] = properties.lsc_uuid;
    //   options['locName'] = this.gisUtils.titleCase(properties.lsc_cons);
    //   options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + this.gisUtils.titleCase(properties.lsc_cons) + '##' + properties.lsc_uuid;
    // } else if (properties.taluk_uuid) {
    //   options['locType'] = 'TALUK';
    //   options['pUUID'] = properties.taluk_uuid;
    //   options['locName'] = this.gisUtils.titleCase(properties.taluk_name);
    //   options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + allLocations[2] + '&' + this.gisUtils.titleCase(properties.taluk_name) + '##' + properties.taluk_uuid;
    // }else
    const featureUuid = properties['uuid'] || properties['UUID'];
    if (featureUuid && options['locType'] == 'COUNTRY' && (key.includes('State'))) {
      const name = properties['state_name'] ? properties['state_name'] : properties['ba_name']
      const locType = properties['state_name'] ? 'STATE' : 'BASINV2'
      options['locType'] = locType;
      options['pUUID'] = featureUuid;
      options['locName'] = this.gisUtils.titleCase(name);
      options['location'] = allLocations[0] + '&' + this.gisUtils.titleCase(name) + '##' + featureUuid;
      if (!isNullOrUndefined(options['filter'])) {
        options['filter'] = false
      }
    } else if (properties['state_uuid'] && options['locType'] == 'COUNTRY' && !key.includes('State')) {
      options['locType'] = 'STATE';
      options['pUUID'] = properties['state_uuid'];
      options['locName'] = this.gisUtils.titleCase(properties['state_name']);
      options['location'] = allLocations[0] + '&' + this.gisUtils.titleCase(properties['state_name']) + '##' + properties['state_uuid'];
    } else if (properties['uuid'] && options['locType'] == 'STATE') {
      // Block polygons have dist_uuid (their parent district); district polygons do not.
      // Use dist_uuid when present so clicking a block at STATE level drills to the correct district.
      const distUUID = properties['dist_uuid'] || properties['uuid'];
      options['locType'] = 'DISTRICT';
      options['pUUID'] = distUUID;
      options['locName'] = this.gisUtils.titleCase(properties['dist_name']);
      options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + this.gisUtils.titleCase(properties['dist_name']) + '##' + distUUID;
    } else if (properties['uuid'] && options['locType'] == 'DISTRICT' && key.includes('Ward')) { // for UHI
      // ward_lgd_n is prefixed with the municipal corporation name (e.g. "Gurgaon (M Cl ) -
      // Ward No.29") — getWardDisplayName strips that down to just "Ward No.29" for display,
      // matching the same short form the hover popup (setHtmlContentForWard) uses.
      const wardDisplayName = gisMapComp.injectedService && gisMapComp.injectedService.getWardDisplayName
        ? gisMapComp.injectedService.getWardDisplayName(properties['ward_lgd_n'])
        : properties['ward_lgd_n'];
      options['locType'] = 'WARD';
      options['pUUID'] = properties['uuid'];
      options['locName'] = this.gisUtils.titleCase(wardDisplayName);
      options['location'] = allLocations[0] + '&' + this.gisUtils.titleCase(wardDisplayName) + '##' + properties['uuid'];
    } else if (properties['uuid'] && options['locType'] == 'DISTRICT') {
      options['locType'] = 'BLOCK';
      options['pUUID'] = properties['uuid'];
      options['locName'] = this.gisUtils.titleCase(properties['block_name']);
      options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + this.gisUtils.titleCase(properties['dist_name']) + '##' + properties['dist_uuid'] + '&' + this.gisUtils.titleCase(properties['block_name']) + '##' + properties['uuid'];
    } else if (properties['uuid_city'] && options['locType'] == 'COUNTRY') {
      options['locType'] = 'CITY';
      options['pUUID'] = properties['uuid_city'];
      options['locName'] = this.gisUtils.titleCase(properties['Name']);
      options['location'] = allLocations[0] + '&' + this.gisUtils.titleCase(properties['Name']) + '##' + properties['uuid_city'];
    } else if(key == 'Airport Boundary' || key == 'Railway Boundary' || key == 'Highway Boundary') {
      gisMapComp.injectedService.setViewForFogForecastLayers(key, properties, gisMapComp)
    }
    return options;
  }
  // setHtmlForBundsForHA(prop:any) {
  //   let cropInfo :any = JSON.parse(prop?.sourceTarget?.properties?.crop_info_json)
  //   let cropArea:any = this.utilsSrv.convertSqMtrsToHectare(cropInfo.cropAreaa)
  //   var htmlString = "<html><body>";
  //   htmlString += '<div class="popup-table-section inflowClickPopup">';
  //   htmlString += `<div class="card-body p-0">
  //      <table class="table table-sm m-0 table-bordered">`;
  //   htmlString += `<tbody>
  //       <tr>
  //         <th>Crop Name</th>
  //         <td>${cropInfo.cropName ? cropInfo.cropName : '-'}</td>
  //       </tr>
  //         <tr>
  //         <th>Crop Area</th>
  //         <td>${cropInfo.cropAreaa ? parseFloat((cropArea)).toFixed(2) : '-'} (Ha)</td>
  //       </tr>
  //         <tr>
  //         <th>Sowing Date</th>
  //         <td>${cropInfo.sowingDate ? cropInfo.sowingDate : '-'}</td>
  //       </tr>
  //         <tr>
  //         <th>Harvest Date</th>
  //         <td>${cropInfo.harvestDate ? cropInfo.harvestDate : '-'}</td>
  //       </tr>
  //       </table>
  //       </div>
  //       </div>`;
  //        return htmlString;
  // }
  getVECTOROverlays(data: any, params?: any) {
    let overlays: any = {};
    for (const key in data) {
      let element = data[key];
      if (element.type === "VECTOR") {
        const overlay: any = {};
        overlay.type = 'vector';
        overlay.name = element.name;
        overlay.component = element.component;
        overlay.layerOptions = {};
        overlay.layerOptions.interactive = true;
        overlay.layerOptions.name = element.layer_name;
        overlay.layerOptions.rendererFactory = (L as any).canvas.tile;
        overlay.layerOptions.getFeatureId = (feature) => feature.properties.UUID
        if (this.validateValue(element.cql_filter)) {
          overlay.layerOptions.cql_filter = element.cql_filter;
        }
        if (this.validateValue(element.cql_filter_value)) {
          overlay.layerOptions.cql_filter_value = element.cql_filter_value;
        }
        if (this.validateValue(element.viewparams)) {
          overlay.layerOptions.VIEWPARAMS = element.viewparams;
        }
        if (this.validateValue(element.layeroptions_name)) {
          overlay.layerOptions.workspaceName = element.layeroptions_name.split(':')[0];
        }
        if (this.validateValue(element.environment_server_url)) {
          overlay.layerOptions.environment_server_url = element.environment_server_url;
        }
        overlay.url = this.getVectorLayerURL(element.layeroptions_name, overlay.layerOptions);
        overlay.layerOptions.view = element.view;
        overlay.layerOptions.minZoom = element.layeroptions_min_zoom;
        overlay.layerOptions.maxZoom = element.layeroptions_max_zoom;
        overlay.layerOptions.pane = element.layeroptions_pane;
        overlay.layerOptions.visible = element.visible;
        overlay.layerOptions.type = LAYER_TYPES.VECTOR_LAYER;
        if (element.component) {
          overlay.layerOptions.component = element.component;
        }
        if (this.validateValue(element.source))
          overlay.layerOptions.source = element.source;
        if (this.validateValue(element.dashboardView))
          overlay.layerOptions.dashboardView = element.dashboardView;
        if (this.validateValue(element.hasLegend))
          overlay.layerOptions.hasLegend = element.hasLegend;
        if (this.validateValue(element.legendName))
          overlay.layerOptions.legendName = element.legendName;
        overlay.layerOptions.group = element.group;
        overlay.layerOptions.displayName = element.displayName;
        if (this.validateValue(element.layeroptions_show_on_selector) && !element.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = element.layeroptions_show_on_selector;
        if (this.validateValue(element.group_type)) {
          overlay.layerOptions.groupType = element.group_type
        }
        if (this.validateValue(element.layer_name)) {
          overlay.layerOptions.layer_name = element.layer_name
        }
        if (this.validateValue(element.layeroptions_name))
          overlay.layerOptions.layerName = element.layeroptions_name;
        overlay.layerOptions.vectorTileLayerStyles = {};
        if (element.type === 'VECTOR') {
          overlay.key = element;
          overlays[key] = overlay;
        }
      }
    }
    return overlays;
  }
  getVectorLayerURL(layerName: any, options: any) {
    let url: any;
    url = environment.url[options.environment_server_url] + options.workspaceName
    url += '/gwc/service/wmts?layer=' + layerName + '&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}';
      if (this.validateValue(options.cql_filter)) {
        url += '&cql_filter=' + options.cql_filter;
      }
     if (this.validateValue(options.VIEWPARAMS)) {
        url += '&VIEWPARAMS=' + options.VIEWPARAMS;
      }

    return url;
  }
  addSourceWiseLayers(layerList: any, gisMapComp: any, params?: any, stage?: any) {
    let layers: any = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      if (layerList[i].layerOptions.layer_name == 'Visualization Layer') {
        layerList[i].layerOptions.cql_filter = layerList[i].layerOptions.cql_filter_value + "='" + params.taskUUID + "'";
      } else if (layerList[i].layerOptions.layer_name == 'Unsupervised Visualization Layer') {
        layerList[i].layerOptions.viewparams = "&viewparams=task_uuid:" + "'" + params.taskUUID + "'";
        layerList[i].layerOptions.parent_cql_filter = layerList[i].layerOptions.parent_cql_filter_key + "='" + params.villUUID + "'";
      } else if (layerList[i].layerOptions.layer_name == 'Intermediate WMS Layer') {
        layerList[i].layerOptions.layers = 'KeralaKrishiStack:component_' + stage + '_computed';
        layerList[i].layerOptions.cql_filter = layerList[i].layerOptions.cql_filter_value + "='" + params.taskUUID + "'";
      }
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }
  addSourceWiseLayersForSupervised(layerList: any, gisMapComp: any, params?: any, stage?: any) {
    let layers: any = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      if (layerList[i].layerOptions.layer_name == 'Visualization Layer') {
        layerList[i].layerOptions.cql_filter = layerList[i].layerOptions.cql_filter_value + "='" + params.taskUUID + "'";
      } else if (layerList[i].layerOptions.layer_name == 'Intermediate WMS Layer') {
        layerList[i].layerOptions.layers = 'KeralaKrishiStack:' + stage;
        layerList[i].layerOptions['VIEWPARAMS'] = layerList[i].layerOptions.cql_filter_value ? (layerList[i].layerOptions.cql_filter_value + ":'" + params.taskUUID + "'") : null;
      } else if (layerList[i].layerOptions.layer_name == 'Unsupervised Visualization Layer') {
        layerList[i].layerOptions['VIEWPARAMS'] = params.taskUUID ? "task_uuid:'" + params.taskUUID + "'" : null;
      }
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }
  setGEOJSONProcessedLayers(mapObj: any, layerList: any, layerObjectsList: any, otherOptions: any, gisMapComp?: any, params?: any) {
    return new Promise(async (resolve, reject) => {
      let geoJsonOverlay: any = {};
      let filter = null;
      for (const key in layerList) {
        if (layerObjectsList.processedLayers.hasOwnProperty(key)) {
          if (mapObj.hasLayer(layerObjectsList['processedLayers'][key])) {
            mapObj.removeLayer(layerObjectsList['processedLayers'][key]);
          }
        }
        let layerGroup: any = new L.LayerGroup();
        const val = layerList[key];

        if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == AgricultureMapConstants.SOURCES.GEOSERVER) {
          if (val.layerOptions.displayName == 'Unsupervised Visualization Layer') {  // condition to apply viewParams on layer
            filter = this.getviewParamsFilterForLayers(val.layerOptions)
          }
          else {
            filter = this.getCqlFilterForLayers(val.layerOptions);
          }
          let layerName = val.layerOptions.layers.includes('HEATWAVE:') ? val.layerOptions.layers.split('HEATWAVE:') : val.layerOptions.layers.split('odisha:');
          let workspaceName: any = val.layerOptions.layers.split(':')[0];
          let environment_server_url: any = val.layerOptions.environment_server_url;
          let protocol: any = val.layerOptions.protocol;
          // filter = this.getCqlFilterForLayers(val.layerOptions);
          if (layerName[1] != null || layerName[1] != undefined) {
            var geodata: any;
            if (protocol == 'WFS') {
              geodata = await this.getGeoJsonLayerData(layerName[1], filter, workspaceName, environment_server_url, protocol,gisMapComp);
            } else if (protocol == 'WMS') {
              geodata = await this.getGeoJsonVectorLayerData(layerName[1], workspaceName, filter, val.layerOptions);
            }
            // var geodata = await this.getGeoJsonLayerData(layerName[1], filter, workspaceName, environment_server_url, protocol);
            layerGroup = await this.addGeoJsonLayersToMap(geodata, mapObj, val.layerOptions, otherOptions, gisMapComp, params);
          }
        }

        layerGroup['options'] = { ...val, ...layerGroup['options'] };
        geoJsonOverlay[key] = {};
        geoJsonOverlay[key]['data'] = geodata;
        geoJsonOverlay[key]['layerConfig'] = layerGroup;
        geoJsonOverlay[key]['baseMapSrc'] = params.baseMapSrc;
        geoJsonOverlay[key]['baseMapName'] = params.baseMapName;
        geoJsonOverlay[key].layerConfig.options = { ...geoJsonOverlay[key].layerConfig.options, ...layerGroup['options']['layerOptions'] };
      }
      resolve(geoJsonOverlay);
    });
  }
  getHeatMapOverlays(layersList: any, imageData?: any) {
    var overlays: any = {};
    for (const key in layersList) {
      if (layersList.hasOwnProperty(key)) {
        const value = layersList[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'image';
        overlay.layerOptions = {};
        overlay.layerOptions.name = value.name;
        if (this.validateValue(imageData[overlay.name]))
          // overlay.bounds = this.getBlockBoundsForType(basinName)
          if (this.validateValue(value.group_type)) {
            overlay.layerOptions.groupType = value.group_type
          }
        if (this.validateValue(value.component))
          overlay.layerOptions.component = value.component;
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.key))
          overlay.layerOptions.key = value.key;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.legendData))
          // overlay.layerOptions.legendData = legendData ? legendData : value.legendData;
          if (this.validateValue(value.subgroup))
            overlay.layerOptions.subgroup = value.subgroup;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.type))
          overlay.layerOptions.type = value.type;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layerName = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (value.type === 'HEATMAP' && !this.validateValue(value.image_path)) {
          if (this.validateValue(imageData[overlay.name])) {
            overlay.url = imageData[overlay.name].url
            overlays[key] = overlay;
          }
          else {
            overlay.url = imageData[value.layeroptions_name];
            overlays[key] = overlay;
          }
        } else if (value.type === 'HEATMAP' && this.validateValue(value.image_path)) {
          overlay.url = value.image_path;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
      }
    }
    return overlays;
  }
  setImageLayers(mapObj: any, imageLayers: any, layerList: any, imageData: any) {
    let options: any = {
      opacity: 0.8,
      pane: 'heatMap',
      minZoom: 6,
      maxZoom: 15,
      clip: imageData['bbox']
    };
    let data = this.setHeatMapData(imageData['heatmapData'], imageData['bbox']);
    let layers: any = {};
    for (const key in imageLayers) {
      if (imageLayers.hasOwnProperty(key)) {
        const layer: any = imageLayers[key];
        if (data['url'] != null && data['url'] != undefined) {
          var anchors: any = this.getImageBounds(data['bounds']);
          // let imglayer = (L as any).imageTransform(data['url'],anchors ,options);
          let imglayer: any = L.imageOverlay(data['url'], anchors, options)
          layers[key] = imglayer;
          layers[key]['options'] = Object.assign(layer['layerOptions'], options)
        }
      }
    }
    return layers;
  }
  setHeatMapData(data: any, bbox: any) {
    let obj: any = {};
    let imageUrl: any = {};
    let imageBounds: any = [];
    imageUrl = data['heatMapImage'];
    let latlongs: any = [];
    latlongs.push(bbox[1]);
    latlongs.push(bbox[0]);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(bbox[3]);
    latlongs.push(bbox[2]);
    imageBounds.push(latlongs);
    obj['url'] = 'data:image/jpeg;base64,' + imageUrl;
    obj['bounds'] = imageBounds;
    return obj;
  }
  getImageBounds(imageBounds: any) {
    var anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]])
    anchors.push([imageBounds[1][0], imageBounds[1][1]])
    anchors.push([imageBounds[0][0], imageBounds[1][1]])
    anchors.push([imageBounds[0][0], imageBounds[0][1]])
    return anchors;
  }
  handleVillagePolygons() {
    let styles: any = {
      fill: false,
      color: '#00ffff',
      weight: 2.2
    }
    return styles;
  }
  // setImageLayers(mapObj, imageLayers, layerList,imageData) {
  //   let options = {
  //     opacity: 0.8,
  //     pane: 'heatMap',
  //     minZoom: 6,
  //     maxZoom: 15,
  //     clip : imageData['bbox']
  //   };
  //   let data = this.pdService.setHeatMapData(imageData['heatmapData'])
  //   let layers = {};
  //   for (const key in imageLayers) {
  //     if (imageLayers.hasOwnProperty(key)) {
  //       const layer: any = imageLayers[key];
  //       if(data['url']!= null && data['url'] != undefined){
  //         var anchors = this.getImageBounds(data['bounds']);
  //         // layer['layer'] = L.imageTransform('assets/SampleCSV_imgs/wqValues_windspeed_432382632516.png',anchors,options);
  //         // console.log(data['url'],anchors,options)
  //         let imglayer = (L as any).imageTransform(data['url'],anchors,options);
  //         layers[key] = imglayer;
  //         // console.log(imglayer,"imglayer")
  //         layers[key]['options'] = Object.assign(layer['layerOptions'],options)
  //         if (mapObj.hasLayer(layerList[key]))
  //           mapObj.removeLayer(layerList[key]);
  //         if (layer.layerOptions.visible === true) {
  //           mapObj.addLayer(layers[key])
  //         }
  //       }
  //     }
  //   }
  //   return layers;
  // }
  setImageLayersWithImageBounds(mapObj: any, imageLayers: any, layerList: any, imageData: any, component: any) {
    let options: any = {
      opacity: 0.8,
      pane: 'base',
      minZoom: 2,
      maxZoom: 15,
      clip: imageData['bbox']
    };
    let layers: any = {};
    setTimeout(() => {
      let data = this.setHeatMapImages(imageData['heatmapData'], component)
      for (const key in imageLayers) {
        if (imageLayers.hasOwnProperty(key)) {
          const layer: any = imageLayers[key];
          if (!isNullOrUndefined(data.url)) {
            var anchors: any = this.getImageBounds(data['bounds']);
            let imglayer: any = L.imageOverlay(data['url'], anchors, options);
            // let imglayer = (L as any).imageTransform(data['url'],anchors,options);
            layers[key] = imglayer;
            layers[key]['options'] = Object.assign(layer['layerOptions'], options)
          }
        }
      }
    }, 100)
    return layers;
  }
  setHeatMapImages(data: any, component: any) {
    let obj: any = {};
    let imageUrl = {};
    let imageBounds = [];
    imageUrl = data['heatMapImage'];
    let latlongs = [];
    latlongs.push(data['heatMapImageBound']['_southWest']['lat']);
    latlongs.push(data['heatMapImageBound']['_southWest']['lng']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(data['heatMapImageBound']['_northEast']['lat']);
    latlongs.push(data['heatMapImageBound']['_northEast']['lng']);
    imageBounds.push(latlongs);
    obj['url'] = component == 'CROPGROWTHANALYSIS' ? this.urlConstants.AimsBaseUrl + '/cga/files/' + imageUrl : imageUrl;
    obj['bounds'] = imageBounds;
    return obj;
  }

  public getFeatureInfo(latlng: any, layer: any, map: any) {
    let url = this.getFeatureInfoUrl(latlng, layer, map);
    return this.http.get(url).pipe(
      catchError((err) => {
        return EMPTY;
      })
    );
  }
  public getFeatureInfoUrl(latlng: any, layer: any, map: any) {

    // if(!isNullOrUndefined(latlng.latlng)){
    //   latlng = latlng.latlng
    // }
    let point = map.latLngToContainerPoint(latlng, map.getZoom());
    let size = map.getSize();
    let params: any = {
      request: 'getFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      transparent: true,
      version: layer ? layer.wmsParams.version : '',
      format: layer ? layer.wmsParams.format : '',
      bbox: map.getBounds().toBBoxString(),
      height: Math.floor(size.y),
      width: Math.floor(size.x),
      layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      query_layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      info_format: 'application/json',
      feature_count: 50,
      VIEWPARAMS: layer ? (layer.wmsParams.VIEWPARAMS ? layer.wmsParams.VIEWPARAMS : '1=1') : ''
      // CQL_FILTER: layer ? (layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1') : ''
    };
    params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
    params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
    let url = layer._url + L.Util.getParamString(params, layer._url, true);
    return url;
  }

  addMaskLayer(layerList: any, params: any, componentName?: any, type?: any) {
    // let componentName :any = gisMapComp.params.component;
    // console.log("layerList::: ",layerList,type)
    layerList['world_view'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['world_view'];
    // if(!isNullOrUndefined(params.type) && params.type == 'revenue') {
    if (params.view == 'Admin' || params.view == 'HEATMAP') {
      layerList['world_view']['layeroptions_name'] = componentName != 'KOLKATAEVENT' ? "HEATWAVE:world_view," + AgricultureMapConstants.LOCTYPE_LAYERNAME[params.locType] : "HEATWAVE:world_view,HEATWAVE:Kolkata_outerboundary"
    // console.log("layerList::::iffff ",layerList)
    } else if(params.view == 'City'){
      layerList['world_view']['layeroptions_name'] = params.pUUID != 'd49a7f7d-3437-42a5-999c-e62c8878f1a3' ? "HEATWAVE:world_view," + AgricultureMapConstants.LOCTYPE_LAYERNAME_REVENUE[params.locType] : "HEATWAVE:world_view,HEATWAVE:Kolkata_outerboundary";
      if(componentName == 'KOLKATANOWCAST') {
        layerList['world_view']['layeroptions_name'] = "HEATWAVE:world_view,HEATWAVE:Kolkata_outerboundary";
      }
  //  console.log("layerList:::else ",layerList)
    }
    layerList['world_view']['layeroptions_styles'] = 'HEATWAVE:world_view_white,HEATWAVE:inverse_mask'
    layerList['world_view']['environment_server_url'] = 'COMMON_GEOSERVER_URL'
    return layerList;
  }
}
